const routes = {
  root: '/self-assessment/details',
}

export default routes
